import { Component, Input, OnInit } from '@angular/core';
import { PaginationPageEvent } from '@snapon/design-system-angular';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { InvoicesService } from '../services/invoices.service';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss'],
  standalone: false
})
export class InvoiceDetailsComponent implements OnInit {
  appStrings: AppLocalization;
  invoiceDetailsResult;
  totalRecords = 0;
  currentPage = 0;
  pageSize = 50;
  pageOffset = 0;
  totalPages: number;
  invoiceDetails;
  dataLoaded = {
    templateValues: false,
    invoiceDetails: false,
  };

  displayedColumns: string[] = [
    'erp',
    'product',
    'productName',
    'description',
    'warehouse',
    'shipQuantity',
    'backQuantity',
    'orderQuantity',
    'unitPrice',
    'totalPrice'
  ];
  @Input() invoiceNumber;
  @Input() currencySymbol;

  constructor(
    private appInfoService: AppInfoService,
    private invoicesService: InvoicesService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.getResults(0);
  }

  loadPage(event: PaginationPageEvent) {
    this.dataLoaded.invoiceDetails = false;
    this.currentPage = event.pageNumber;
    this.getResults(event.pageNumber);
    this.pageOffset = (event.pageNumber - 1) * this.pageSize;
  }

  getResults(pageIndex) {
    this.invoicesService.getInvoiceDetails({ invoiceNumber: this.invoiceNumber, page: pageIndex + 1 }, invoiceDetails => {
      this.invoiceDetailsResult = invoiceDetails.items;
      this.dataLoaded.templateValues = true;
      this.dataLoaded.invoiceDetails = true;
      this.totalRecords = invoiceDetails.count;
      this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
    });
  }

}
